import moment from 'moment';
import { isEditorialCourse } from './course';
import { parseUserForHorizontalGraphic } from './parses';
import { isLemonadeQuestion, isLemonadeTest, isScorm, isVideolesson, isxApi } from './utils';

export function moveSectionUpDown(_currentLesson, _index, newPosition, _callback) {
  // Moviendo
  const result = _currentLesson.sections;
  const [removed] = result.splice(_index, 1);
  result.splice(newPosition, 0, removed);
  _currentLesson.sections = result;

  // Armando array de orden
  var _ar = [];
  var _order = 0;
  _currentLesson.sections.map((_sec) => {
    _order++;
    _ar.push({ guid: _sec.guid, name: _sec.name, order: _order, parent_guid: null });
    _sec.items.map((_les) => {
      _order++;
      _ar.push({ guid: _les.guid, name: _les.name, order: _order, parent_guid: _sec.guid });
    });
  });

  _callback(_currentLesson, _ar);
}

export function refreshTestContentData(_currentLesson, _tests, _content, _lessonItemGuid, _callback, newCourseMessage) {
  var objSupport = {};
  objSupport.students = []; // Array total de alumnos
  objSupport.toStudents = []; // Array total de alumnos
  objSupport.turned = 0; // Cantidad de alumnos que entregaron
  objSupport.graded = 0; // Cantidad de alumnos calificados
  objSupport.questionsLength = ''; // Cantidad de questions

  var _countUsersPromedio = 0;
  var _sumUsersPromedio = 0;

  if (isLemonadeTest(_tests.content_type_guid) || isVideolesson(_tests.content_type_guid) || isLemonadeQuestion(_tests.content_type_guid)) {
    _tests.jobs.map((job) => {
      // Array total de alumnos
      objSupport.students.push({
        name: job.student_name + ' ' + job.student_lastname,
        score: job.score,
        status: job.status,
        guid: job.student_guid,
        thumbnail: job.student_avatar,
        turned: job.status == 'pending' ? false : true, // true : para los que no entregaron
      });

      // Cantidad de alumnos que entregaron
      objSupport.turned = job.status == 'delivered' ? objSupport.turned + 1 : objSupport.turned;
      // Cantidad de alumnos calificados
      objSupport.graded = job.status == 'evaluated' ? objSupport.graded + 1 : objSupport.graded;

      // calculando promedio de JOB de alumno
      if (job.status != 'pending') {
        let timeTotalTest = parseInt(_content.time) * 60 * 1000; // Tiempo total del test pasados a milisegundos
        let _metadata = null;
        try {
          _metadata = JSON.parse(job.metadata);
        } catch (e) {
          console.log(e, 'error refreshTestContentData');
        }

        _countUsersPromedio++;
        if (_metadata && _metadata.lefts && _metadata.lefts.total) {
          _sumUsersPromedio = _sumUsersPromedio + (timeTotalTest - _metadata.lefts.total) / 60 / 1000;
        }
      }
    });
  }

  if (isScorm(_tests.content_type_guid) || isxApi(_tests.content_type_guid)) {
    _tests.jobs.map((job) => {
      // Array total de alumnos
      objSupport.students.push(parseUserForHorizontalGraphic(job));
    });
  }

  if (_tests.item_for === 'all') {
    objSupport.toStudents = [...objSupport.students];
  } else {
    let studentFind = null;
    for (const user of _tests.item_for_users.split(',')) {
      studentFind = objSupport.students.find((item) => item.guid === user);
      if (studentFind) {
        objSupport.toStudents.push(studentFind);
      }
    }
  }

  _sumUsersPromedio = _sumUsersPromedio / _countUsersPromedio;

  _currentLesson.sections = _currentLesson.sections.map((_sec) => {
    return {
      ..._sec,
      items: _sec.items.map((_item) => {
        if (_item.guid == _lessonItemGuid) {
          _item.toStudents = objSupport.toStudents;
          _item.students = objSupport.students;
          _item.turned = objSupport.turned;
          _item.graded = objSupport.graded;
          //_item.questionsLength = "----"
          _item.averageTime = _sumUsersPromedio ? _sumUsersPromedio.toFixed(2) + ' m' : '-';
          if (newCourseMessage) {
            _item.course_message_guid = newCourseMessage;
          }
          return _item;
        } else {
          return _item;
        }
      }),
    };
  });

  _callback(_currentLesson);
}

// Obtener la duración de un audio o vídeo, y setear en el Item su valor
export function getTotalTimeMedia(_currentLesson, element_item, _callback) {
  var au = document.createElement('audio');
  au.src = element_item.content_url;
  au.addEventListener(
    'loadedmetadata',
    function () {
      var duration = au.duration;
      let _hours = moment.duration(Number(duration), 'seconds').hours();
      let _minutes = moment.duration(Number(duration), 'seconds').minutes();
      let _seconds = moment.duration(Number(duration), 'seconds').seconds();
      let _Fulltime =
        (_hours < 10 ? '0' + _hours : _hours) + ':' + (_minutes < 10 ? '0' + _minutes : _minutes) + ':' + (_seconds < 10 ? '0' + _seconds : _seconds);

      _currentLesson.sections = _currentLesson.sections.map((_sec) => {
        return {
          ..._sec,
          items: _sec.items.map((_item) => {
            return {
              ..._item,
              contentDurationTime: _item.guid == element_item.guid ? _Fulltime : _item.contentDurationTime || null,
            };
          }),
        };
      });

      // RETURN
      _callback(_currentLesson);
    },
    false
  );
}

// Seteando objeto lesson con los contadores de questions que tiene el test
export function refreshCountsQuestionsOfTest(el_item, _currentLesson, _callback) {
  _currentLesson.sections = _currentLesson.sections.map((_sec) => {
    return {
      ..._sec,
      items: _sec.items.map((_item) => {
        return {
          ..._item,
          questionsLength:
            _item.content_guid == el_item.guid && _item.content_type_guid == 'CTTY_09'
              ? el_item.data.questions.length
              : _item.content_type_guid == 'CTTY_14'
              ? 1
              : _item.questionsLength,
        };
      }),
    };
  });

  _callback(_currentLesson);
}

// Recuperando comentarios de element
export function parserAllMessages(_currentLesson, _lessonItemGuid, _lessonItemMessages, _callback) {
  var _messages = [];
  if (_lessonItemMessages.data.data.amount_comments > 0) {
    _messages = _lessonItemMessages.data.data.comments
      .sort(function (a, b) {
        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
      })
      .map((m) => {
        return {
          user: {
            name: m.creator_name,
            lastName: m.creator_lasname,
            email: 'wwww@mail.com',
            creator_guid: m.creator_guid,
            guid: m.creator_guid,
            avatar: m.creator_avatar,
            //"thumbnail": m.creator_avatar
          },
          creator_guid: m.creator_guid,
          text: m.message,
          guid: m.guid,
          createdAt: m.created_at,
        };
      });
  }

  _currentLesson.sections = _currentLesson.sections.map((_sec) => {
    return {
      ..._sec,
      items: _sec.items.map((_item) => {
        return {
          ..._item,
          comments: _item.guid == _lessonItemGuid ? _messages : _item.comments,
        };
      }),
    };
  });

  _callback(_currentLesson);
}

export function parseOnPublishComment(_currentLesson, parentGuid, _postMessaje, _callback) {
  var _msj = {
    user: {
      name: _postMessaje.data.data.creator_name,
      lastName: _postMessaje.data.data.creator_lasname,
      email: 'wwww@mail.com',
      creator_guid: _postMessaje.data.data.creator_guid,
      guid: _postMessaje.data.data.creator_guid,
      avatar: _postMessaje.data.data.creator_avatar,
      //"thumbnail": m.creator_avatar
    },
    creator_guid: _postMessaje.data.data.creator_guid,
    text: _postMessaje.data.data.message,
    guid: _postMessaje.data.data.guid,
    createdAt: _postMessaje.data.data.created_at,
  };

  _currentLesson.sections = _currentLesson.sections.map((_sec) => {
    return {
      ..._sec,
      items: _sec.items.map((_item) => {
        var _ar = _item.comments;
        if (_item.course_message_guid == parentGuid) {
          _ar.push(_msj);
        }
        return {
          ..._item,
          comments: _ar,
        };
      }),
    };
  });

  _callback(_currentLesson);
}

// Seteando objeto lesson con los contadores de questions que tiene el test
export function isLessonItemContentType(typeContent, type) {
  return (
    (type === 'image' && typeContent === 'CTTY_07') ||
    (type === 'assessment' && typeContent === 'CTTY_09') ||
    (type === 'question' && typeContent === 'CTTY_14') ||
    (type === 'video' && typeContent === 'CTTY_03') ||
    (type === 'audio' && typeContent === 'CTTY_04') ||
    (type === 'link' && typeContent === 'CTTY_06') ||
    (type === 'task' && typeContent === 'CTTY_09') ||
    (type === 'pdf' && (typeContent === 'CTTY_05' || typeContent === 'CTTY_12')) ||
    (type === 'fixed-layout' && typeContent === 'CTTY_01') ||
    (type === 'scorm' && typeContent === 'CTTY_10') ||
    (type === 'xapi' && typeContent === 'CTTY_20') ||
    (type === 'videolesson' && typeContent === 'CTTY_VIDEOLESSON')
  );
}

export function isTeacherItem(item) {
  return item?.is_customized || item?.is_customized === true;
}

/**
 * Pseudo-sección que parseAllLesson crea para un ítem sin sección: su guid es el del ítem, así que no admite hijos.
 * Se exige `content_type_guid` porque parseAllLesson también marca 'no-section' una sección real sin nombre, y
 * en la respuesta de `front/lessons/:guid/items` solo los ítems lo traen (no `content_type`, que es de la v3).
 */
export function isLooseItemSection(section) {
  return section?.section === 'no-section' && Boolean(section?.content_type_guid);
}

export function isEditorialLessonItem(course, item) {
  if (!item) return false;
  if (!isEditorialCourse(course)) return false;
  return !isTeacherItem(item) || Boolean(item.lesson_item_editorial_guid);
}

export function isTeacherOnlyItem(item) {
  return item?.content_is_teacher_only === 1;
}
